module.exports = __webpack_public_path__ + "static/metaverse_devices-040072b78d0f93e7e4009859f5887681.svg";